import { Badge } from '@/components/ui/Badge';

interface InvoiceStatusBadgeProps {
  status: string;
}

export function InvoiceStatusBadge({ status }: InvoiceStatusBadgeProps) {
  const variant = status === 'paid' ? 'success' : status === 'pending' ? 'warning' : status === 'failed' ? 'danger' : 'neutral';
  const label = status === 'paid' ? 'Payee' : status === 'pending' ? 'En attente' : status === 'failed' ? 'Echouee' : status;

  return <Badge variant={variant}>{label}</Badge>;
}
